import React, {useRef, useState} from 'react';
import {FormGroup, Input, Label} from 'reactstrap';
import ReactSelect from '../../components/react-select';
import {Input as UInput} from '../../components/input';
import {Form} from '@unform/web';
import * as Yup from 'yup';
import './device.sass';
import ToggleButton from '../../components/toggle-button';
import ReactSelectCategory from '../../components/react-select-category';
import I18nMessage from '../../components/I18nMessage';
import {KmhToKnots, knotsToKmH} from "../../helpers/conversions";
import {GroupButtonForm} from "../../components/group-button-form";
import {FieldSet} from "../../components/fieldset";
import AutoComplete from "../../components/autocomplete-input";
import {getSnapshot} from "mobx-state-tree";

const DeviceAdminForm = (props) => {
    const {
        cancel,
        data,
        edit,
        newRegister,
        updateRegister,
        groups,
        equipments,
        categories,
        loading,
        fullControlStore,
        session
    } = props;

    const formRef = useRef(null);
    const [category, setCategory] = useState(data.category); // TODO fix the react-select-category to bind the schema data

    const schema = Yup.object().shape({
        id: Yup.number().notRequired(),
        name: Yup.string().required('Nome é necessário'),
        uniqueId: Yup.string().required('Indentificador é necessário'),
        groupId: Yup.string().notRequired(),
        phone: Yup.string().notRequired(),
        model: Yup.string().notRequired(),
        contact: Yup.string().notRequired(),
        category: Yup.string().notRequired(),
        disabled: Yup.boolean().notRequired(),
        attributes: Yup.object().shape({
            cc_email: Yup.string().notRequired(),
            m2mProvider: Yup.string().notRequired(),
            iccid: Yup.string().notRequired(),
            vehicleModel: Yup.string().notRequired(),
            plate: Yup.string().notRequired(),
            year: Yup.string().notRequired(),
            fuelType: Yup.string().notRequired(),
            fuelConsumption: Yup.string().notRequired(),
            manufacturer: Yup.string().notRequired(),
            color: Yup.string().notRequired(),
            renavan: Yup.string().notRequired(),
            chassi: Yup.string().notRequired(),
            devicePassword: Yup.string().notRequired(),
            speedLimit: Yup.string().notRequired(),
            installationLocation: Yup.string().notRequired(),
            technician: Yup.string().notRequired(),
            ignoreOdometer: Yup.boolean().default(false),
        })
    });

    const cast = (src) => {
        const data = Object.assign({}, src);
        if (data.attributes) {
            const attributes = Object.assign({}, data.attributes);
            if (attributes.hasOwnProperty('speedLimit')) {
                attributes.speedLimit = knotsToKmH(attributes.speedLimit);
            }

            data.attributes = attributes;
        }
        return data;
    }

    const handleF8Key = () => {
        formRef.current.submitForm();
    }

    const handleSubmit = async (payload) => {

        try {
            payload.category = category;
            if (payload.attributes) {
                const attributes = Object.assign({}, payload.attributes);
                if (attributes.hasOwnProperty('speedLimit')) {
                    attributes.speedLimit = KmhToKnots(payload.attributes.speedLimit);
                }
                payload.attributes = attributes;
            }
            await schema.validate(payload, {
                abortEarly: false,
            });
            payload = schema.cast(payload);
            edit ? updateRegister(Object.assign(data, payload)) : newRegister(payload);
        } catch (err) {
            console.log(err);
            const validationErrors = {};
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
            }
        }
    };

    const onChange = (data) => {
        setCategory(data.id);
    };

    const onIdentifierSelect = async (value) => {

         const equipments = getSnapshot(fullControlStore.getEquipments());
         const equipment  = equipments.find( e => e.equipamento === value);

         if(equipment){

             const simCard = await fullControlStore.getSimCardById(equipment.simCardId);
             const operadora = await fullControlStore.getOperadoraById(simCard.operadoraId);

             formRef.current.setData({
                 uniqueId: value,
                 name: equipment.veiculo.veiculo,
                 model: equipment.modeloEquipamento,
                 attributes: {
                     m2mProvider: operadora.descricao,
                   //  iccid: Yup.string().notRequired(),
                     vehicleModel: equipment.veiculo.modelo,
                     plate: equipment.veiculo.placa,
                     year: equipment.veiculo.ano,
                     fuelType: equipment.veiculo.combustivel,
                     fuelConsumption: equipment.veiculo.consumo,
                     color: equipment.veiculo.cor,
                     chassi: equipment.veiculo.numeroChassi,
                     speedLimit: equipment.veiculo.limiteVelocidade
                 }
             });
         }
    }

    return (
        <Form
            ref={formRef}
            onSubmit={handleSubmit}
            schema={schema}
            initialData={cast(data)}>

            {!!edit && <UInput hidden type="number" name="id"/>}

            <FieldSet className="text-left border p-4" title={'Identificação'}>
                <div className="row">
                    <div className={'col'}>

                        <FormGroup className="custom-formGroup">
                            <Label for="name"><I18nMessage id="sharedName"/>*</Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="name"
                                id="name"
                            />
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="category"><I18nMessage id="deviceCategory"/></Label>
                            <ReactSelectCategory
                                id={'category'}
                                name="category"
                                options={categories}
                                onChange={onChange}/>
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceContact"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="contact"
                                id="contact"
                            />
                        </FormGroup>

                    </div>
                    <div className={'col'}>

                        <FormGroup className="custom-formGroup">
                            <Label for="name"><I18nMessage id="deviceIdentifier"/>*</Label>
                            {
                                session.attributes &&
                                session.attributes.hasOwnProperty('payment_provider') &&
                                session.attributes.payment_provider === 'FULL_CONTROL' ?
                                    <AutoComplete
                                        suggestions={getSnapshot(fullControlStore.getEquipments())}
                                        label={'equipamento'}
                                        name={'uniqueId'}
                                        onSelect={onIdentifierSelect}
                                        id="uniqueId"/> :
                                    <Input
                                        tag={UInput}
                                        type="text"
                                        name="uniqueId"
                                        id="uniqueId"
                                    />
                            }
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="groupId"><I18nMessage id="groupParent"/></Label>
                            <ReactSelect
                                id={'groupId'}
                                name="groupId"
                                options={groups}/>
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="disabled"><I18nMessage id="sharedDisabled"/></Label>
                            <ToggleButton
                                name={'disabled'}
                                id={'disabled'}/>
                        </FormGroup>

                    </div>
                </div>
            </FieldSet>
            <br/>
            <FieldSet className="text-left border p-4" title={'Rastreador'}>
                <div className="row">
                    <div className={'col'}>

                        <FormGroup className="custom-formGroup">
                            <Label for="model"><I18nMessage id="deviceModel"/></Label>
                            <ReactSelect id={'model'} name="model" options={equipments}/>
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceIccid"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.iccid"
                                id="iccid"
                            />
                        </FormGroup>

                    </div>
                    <div className={'col'}>

                        <FormGroup className="custom-formGroup">
                            <Label for="phone"><I18nMessage id="sharedPhone"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="phone"
                                id="phone"
                            />
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceM2mProvider"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.m2mProvider"
                                id="m2mProvider"
                            />
                        </FormGroup>

                    </div>
                </div>
            </FieldSet>
            <br/>
            <FieldSet className="text-left border p-4" title={'Veículo'}>
                <div className="row">
                    <div className={'col'}>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="devicePlate"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.plate"
                                id="plate"
                            />
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceVehicleModel"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.vehicleModel"
                                id="vehicleModel"
                            />
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceYear"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.year"
                                id="year"
                            />
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceChassi"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.chassi"
                                id="chassi"
                            />
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceInstallationLocation"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.installationLocation"
                                id="installationLocation"
                            />
                        </FormGroup>

                    </div>
                    <div className={'col'}>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceManufacturer"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.manufacturer"
                                id="manufacturer"
                            />
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceColor"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.color"
                                id="color"
                            />
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceRenavan"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.renavan"
                                id="renavan"
                            />
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceFuelType"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.fuelType"
                                id="fuelType"
                            />
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceTechnician"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.technician"
                                id="technician"
                            />
                        </FormGroup>

                    </div>
                </div>
            </FieldSet>
            <br/>
            <FieldSet className="text-left border p-4" title={'Configurações'}>
                <div className="row">
                    <div className={'col'}>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceFuelConsumption"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.fuelConsumption"
                                id="fuelConsumption"
                            />
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="devicePassword"/></Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.devicePassword"
                                id="devicePassword"
                            />
                        </FormGroup>

                    </div>
                    <div className={'col'}>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceSpeedLimit"/> (Km/h)</Label>
                            <Input
                                tag={UInput}
                                type="text"
                                name="attributes.speedLimit"
                                id="speedLimit"
                            />
                        </FormGroup>

                        <FormGroup className="custom-formGroup">
                            <Label for="contact"><I18nMessage id="deviceIgnoreOdometer"/></Label>
                            <ToggleButton name={'attributes.ignoreOdometer'} id={'ignoreOdometer'}/>
                        </FormGroup>

                    </div>
                </div>
            </FieldSet>
            <br/>
            <GroupButtonForm
                loading={loading}
                cancel={cancel}
                submit={handleF8Key}
            />
        </Form>
    );
};

export default DeviceAdminForm;
